import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { InfraService } from './infra.service';

@Injectable()
export class MappingRemediationService {
  private coreAPIUrl: string;

  constructor(private infraService: InfraService, private _http: HttpClient) {
    this.infraService.infraDetails$.subscribe(data => {
      this.coreAPIUrl = data.WebEndPoint2 + 'MappingRemediation';
    });

    if (!this.infraService.isInfraDetailsAvailable && localStorage.getItem('selectedInfra') != undefined) {
      this.infraService.isInfraDetailsAvailable = true;
      this.infraService.setInfraDetails(localStorage.getItem('selectedInfra'));
    }
  }

  // To get default mapping data for lookup (Mapping1, Mapping2, Mapping3)
  getMappingData(engagementId: number) {
    return this._http.get(`${this.coreAPIUrl}/Getmappingdata/${engagementId}`);
  }

  getMappingSuggestion(engagementId: number, pageNumber: number, pageSize: number, sortColumn: string, sortOrder: string,
    filterAccId: string, filterAccDescription: string, filterLibrary: string, filterMappingSuggestions: any,
    suggestioCondition: string, filterMapping2: string, filterMapping3: string
    , filterMapping4: string, filterMapping5: string, filterMapping6: string, filterMapping7: string) {
    return this._http.post(`${this.coreAPIUrl}/GetMappingSuggestion`, {
      'EngagementId': engagementId, 'PageNumber': pageNumber,
      'PageSize': pageSize, 'SortOrder': sortOrder, 'SortColumn': sortColumn, 'FilterAccId': filterAccId,
      'FilterAccDescription': filterAccDescription, 'FilterLibrary': filterLibrary,
      'FilterMappingSuggestions': filterMappingSuggestions, 'FilterMappingSuggestionsCondition': suggestioCondition,
      'FilterMapping2': filterMapping2, 'FilterMapping3': filterMapping3, 'FilterMapping4': filterMapping4, 'FilterMapping5': filterMapping5
      , 'FilterMapping6': filterMapping6, 'FilterMapping7': filterMapping7
    });
  }

  getMappingSource(engagementId: number) {
    return this._http.get(`${this.coreAPIUrl}/getmappingsource/${engagementId}`);
  }

  // To update the user selected values in Mapping table
  saveMappings(mappingData, engagementId) { // ,
    return this._http.post(`${this.coreAPIUrl}/SaveMappings`, { 'EngagementId': engagementId, 'MappingData': mappingData });
  }

  updateAmount(engagementId: number) {
    return this._http.post(`${this.coreAPIUrl}/updateamount/${engagementId}`, {});
  }

  deleteMapping(mappingDeleteData: any) {
    return this._http.post(`${this.coreAPIUrl}/Deletemapping`, { mappingDeleteData: mappingDeleteData });
  }

  deleteSuggestion(mappingId: number, cleanedAccountDescription: string, deleteValue: string, updateAccountMapping: boolean) {
    return this._http.post(`${this.coreAPIUrl}/Deletesuggestion`, {
      mappingId: mappingId, stdMapping: deleteValue,
      cleanedAccountDescription: cleanedAccountDescription, updateAccountMapping: updateAccountMapping
    });
  }

  pushMappingIntoLibrary(engagementId: number, userId: number) {
    return this._http.post(`${this.coreAPIUrl}/PushMappingIntoLibrary`, { engagementId: engagementId, userId: userId });
  }

  checkMappingStructure(engagementId: number) {
    return this._http.get(`${this.coreAPIUrl}/checkmappingstructure/${engagementId}`);
  }

  public getMappingfile(engagementId: number) {
    return this._http.get(`${this.coreAPIUrl}/${engagementId}`, {
      headers: new HttpHeaders({ 'Content-Type': 'application/octet-stream' }),
      responseType: 'blob'
    });
  }

  checkAutomatedMappingConflict(engagementId: number) {
    return this._http.get(`${this.coreAPIUrl}/CheckAutomatedMappingConflict/${engagementId}`);
  }
}
